import {
	Content,
	FailureImg,
	ResultContent,
	ResultText,
	SuccessImg,
} from "@pages/profile-v2/pages/deposit/baseItems";
import React from "react";
import { Translate } from "react-localize-redux";
import { withRouter } from "react-router-dom";

function Result({ location }) {
	const params = new URLSearchParams(location.search);
	const transactionId = params.get("transaction_id");
	const amountFormatted = params.get("amount_formatted");
	const currency = params.get("currency");
	const status = params.get("status");
	const statusDescription = params.get("status_description");

	return (
		<Translate>
			{({ translate }) => (
				<Content>
					<ResultContent>
						{status === "APPROVED" ? (
							<SuccessImg></SuccessImg>
						) : (
							<FailureImg></FailureImg>
						)}
						<ResultText>
							{status === "APPROVED"
								? translate("DEPOSIT_SUCCESS_TITLE")
								: translate("DEPOSIT_FAILED_TITLE")}
						</ResultText>
						<ResultText>
							<div className="detail">
								{status === "APPROVED"
									? translate("DEPOSIT_SUCCESS", {
											transactionId,
											amountFormatted,
											currency,
										})
									: translate("DEPOSIT_FAILED", {
											statusDescription,
											transactionId,
										})}
							</div>
						</ResultText>
					</ResultContent>
				</Content>
			)}
		</Translate>
	);
}
export default withRouter(Result);
